import { render } from "./JsonViewer.vue?vue&type=template&id=a3ec36be&scoped=true&ts=true"
import script from "./JsonViewer.vue?vue&type=script&lang=ts"
export * from "./JsonViewer.vue?vue&type=script&lang=ts"

import "./JsonViewer.vue?vue&type=style&index=0&id=a3ec36be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3ec36be"]])

export default __exports__